import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'contracts';
const endPointMail = 'mail';

// PAGINATION
export const paginationContracts = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllContracts = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND BY ID
export const findContractById = async id => {
  try {
    const { data } = await api.get(`/${endPoint}/findById/${id}`);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createContract = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateContract = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteContract = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDeleted`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// APPROVE
export const approveContract = async formData => {
  try {
    const { data } = await api.post(`/${endPointMail}/contractApproveAndSendMail`, formData);
    message.success(i18next.t(`messages:${endPoint}.successApproved`));
    return data;
  } catch (error) {
    throw error;
  }
};

paginationContracts.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllContracts.propTypes = {
  filters: PropTypes.object.isRequired,
};

createContract.propTypes = {
  values: PropTypes.object.isRequired,
};

updateContract.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteContract.propTypes = {
  id: PropTypes.string.isRequired,
};
